import React from "react";
import { ProductivitySurveyorTemplate } from "../../Templates/ProductivitySurveyorTemplate";

export const ProductivitySurveyor = () => {
  return <ProductivitySurveyorTemplate />;
};
